import React, { useState } from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import './ProjectPage.css';
import Footer from '../footer/Footer';

/* ---------- Small inline icon set (no extra dependency) ---------- */
const Icon = ({ name }) => {
  const common = {
    width: 26,
    height: 26,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
  };

  switch (name) {
    case 'book':
      return (
        <svg {...common}>
          <path d="M4 4.5A2.5 2.5 0 0 1 6.5 2H20v17H6.5A2.5 2.5 0 0 0 4 21.5v-17Z" />
          <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
        </svg>
      );
    case 'pencil':
      return (
        <svg {...common}>
          <path d="M4 20h4L19.5 8.5a2.1 2.1 0 0 0-3-3L5.5 16.5 4 20Z" />
          <path d="M13.5 6.5l4 4" />
        </svg>
      );
    case 'droplet':
      return (
        <svg {...common}>
          <path d="M12 2.5s6.5 7 6.5 12a6.5 6.5 0 0 1-13 0c0-5 6.5-12 6.5-12Z" />
        </svg>
      );
    case 'sprout':
      return (
        <svg {...common}>
          <path d="M12 21V11" />
          <path d="M12 11C12 6 8 5 4 5c0 5 3 8 8 8Z" />
          <path d="M12 11c0-4 3-6 8-6 0 4.5-3 7-8 7Z" />
        </svg>
      );
    case 'heart':
      return (
        <svg {...common}>
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 1 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78Z" />
        </svg>
      );
    case 'tree':
      return (
        <svg {...common}>
          <path d="M12 3 6 11h3l-4 6h4v4h6v-4h4l-4-6h3L12 3Z" />
        </svg>
      );
    case 'thread':
      return (
        <svg {...common}>
          <circle cx="8" cy="8" r="3" />
          <circle cx="16" cy="16" r="3" />
          <path d="M10.5 9.5 13.5 12.5" />
          <path d="M8 11v4a4 4 0 0 0 4 4h1" />
        </svg>
      );
    case 'palette':
      return (
        <svg {...common}>
          <path d="M12 22C6.48 22 2 17.7 2 12.4 2 7.1 6.6 3 12.2 3 17.6 3 22 6.9 22 11.6c0 3-2.2 5.4-5.1 5.4h-2c-.8 0-1.3.7-1 1.4l.2.5c.3.8-.2 1.6-1.1 1.6Z" />
          <circle cx="7.5" cy="10.5" r="1.5" fill="currentColor" stroke="none" />
          <circle cx="12" cy="7.5" r="1.5" fill="currentColor" stroke="none" />
          <circle cx="16.5" cy="10.5" r="1.5" fill="currentColor" stroke="none" />
          <circle cx="15" cy="15" r="1.3" fill="currentColor" stroke="none" />
        </svg>
      );
    case 'blocks':
      return (
        <svg {...common}>
          <rect x="3" y="10.5" width="6.5" height="6.5" rx="1" />
          <rect x="14.5" y="10.5" width="6.5" height="6.5" rx="1" />
          <rect x="8.75" y="3" width="6.5" height="6.5" rx="1" />
        </svg>
      );
    case 'puzzle':
      return (
        <svg {...common}>
          <path d="M9 4h4v2a2 2 0 1 0 0 4v2h4a2 2 0 1 1 0 4h-4v2H9v-2a2 2 0 1 0 0-4H5V8h4V4Z" />
        </svg>
      );
    case 'pin':
      return (
        <svg {...common}>
          <path d="M12 21s7-6.2 7-11.5A7 7 0 0 0 5 9.5C5 14.8 12 21 12 21Z" />
          <circle cx="12" cy="9.5" r="2.3" />
        </svg>
      );
    default:
      return null;
  }
};

/* ---------- Project data (real content, structured for the new layout) ---------- */
const projects = [
  {
    title: 'Shiksha',
    tag: 'Education',
    image: require('../../Assest/HomeBack/SChool.png'),
    description:
      'HDSI operates two English-medium schools in the tribal region of Melghat, providing affordable, quality education through a low-fee model. Serving children from predominantly tribal communities, the schools offer holistic learning from kindergarten to Grade VII, creating an inclusive environment that nurtures academic excellence, creativity, confidence, and lifelong learning.',
    highlights: ['Kindergarten to Grade VII', 'Low-fee, English-medium model'],
    icon: 'book',
    accent: 'crimson',
  },
  {
    title: 'Sakshar',
    tag: 'Adult Literacy',
    image: require('../../Assest/HomeBack/Women Health.png'),
    description:
      'HDSI’s Adult Literacy Programme empowers rural communities across twelve villages in the Achalpur block of Amravati by equipping adults with essential reading, writing, numeracy, and life skills. The programme enables learners to confidently sign documents, perform everyday calculations, access government services, and actively participate in social and economic life.',
    highlights: ['Active across 12 villages', 'Reading, writing & numeracy'],
    icon: 'pencil',
    accent: 'amber',
  },
  {
    title: 'Wells of Hope',
    tag: 'Water & Sanitation',
    image: require('../../Assest/HomeBack/borewell.jpeg'),
    description:
      'HDSI improves access to safe and sustainable drinking water through the construction of borewells, open wells, and community water conservation initiatives in water-scarce villages. These interventions improve health, reduce the burden of water collection, and strengthen long-term water security.',
    highlights: ['Borewells & open wells', 'Community water conservation'],
    icon: 'droplet',
    accent: 'teal',
  },
  {
    title: 'Jeevika',
    tag: 'Livelihood',
    image: require('../../Assest/HomeBack/Goatry.jpeg'),
    description:
      'HDSI promotes sustainable rural livelihoods through goat rearing, poultry farming, revolving livestock models, and community-based income generation initiatives. By providing training, resources, and ongoing support, families are empowered to achieve long-term economic independence.',
    highlights: ['Goat & poultry rearing', 'Revolving livestock model'],
    icon: 'sprout',
    accent: 'navy',
  },
  {
    title: 'Saksham',
    tag: 'Women Empowerment',
    image: require('../../Assest/HomeBack/saksham.jpeg'),
    description:
      'HDSI strengthens women through Self-Help Groups (SHGs), financial inclusion, leadership development, health and hygiene awareness, and community capacity-building initiatives. The programme empowers women to become active leaders and contributors to sustainable rural development.',
    highlights: ['Self-Help Groups (SHGs)', 'Leadership & financial inclusion'],
    icon: 'heart',
    accent: 'crimson',
  },
  {
    title: 'Green Scout Movement',
    tag: 'Environment',
    image: require('../../Assest/HomeBack/Tree plantaion.jpeg'),
    description:
      'As a national partner of the Green Scout Movement International, HDSI promotes environmental conservation through Miyawaki forests, tree plantation drives, biodiversity restoration, climate awareness, and community-led environmental stewardship for a greener future.',
    highlights: ['Miyawaki forests', 'National partner: Green Scout Intl.'],
    icon: 'tree',
    accent: 'teal',
  },
  {
    title: 'Udyam',
    tag: 'Skills & Enterprise',
    image: require('../../Assest/HomeBack/Tailoring.png'),
    description:
      'HDSI equips young people with practical skills through computer education, tailoring and sewing training, career guidance, entrepreneurship support, and scholarship assistance for higher and international education, preparing them for meaningful employment and self-reliance.',
    highlights: ['Computer & tailoring training', 'Career guidance & scholarships'],
    icon: 'thread',
    accent: 'amber',
  },
];

/* Each program now carries its own icon + accent color, matching the
   colored circle badges in the reference design (purple / green / blue / red) */
/* ---------- Volunteer data, restructured to match ProjectCard shape ---------- */
const volunteerPrograms = [
  {
    title: 'Paint4Purpose',
    tag: 'Educational Art',
    image: require('../../Assest/Volunteering/paint.jpeg'),
    description:
      'Paint4Purpose transforms classrooms into vibrant learning spaces through educational art. Volunteers paint thoughtfully designed educational posters that are professionally framed and installed in classrooms as part of the Curious Classroom initiative. These visual learning aids help create print-rich environments that make concepts easier to understand, spark curiosity, and make learning more joyful, engaging, and effective for children.',
    highlights: ['Poster painting', 'Print rich classrooms'],
    icon: 'palette',
    accent: '#7b2cbf',
  },
  {
    title: 'Green Scout Movement',
    tag: 'Environment',
    image: require('../../Assest/Volunteering/miyawaki.png'),
    description:
      'Green Scout Movement is a community-led environmental initiative that is part of a growing global movement to restore ecosystems, promote biodiversity, and inspire people of all ages to become responsible stewards of nature',
    highlights: ['Tree plantation drives', 'Environmental stewardship'],
    icon: 'tree',
    accent: '#2e7d32',
  },
  {
  title: 'Build4Foundations',
  image: require('../../Assest/Volunteering/ECE.png'),
  tag: 'Infrastructure',
  description:
    "Build4Foundations brings volunteers together to assemble play-based Early Childhood Education (ECE) learning kits for children in underserved communities. Each kit is thoughtfully designed with educational and sensory materials that stimulate cognitive, language, motor, social, and emotional development during the most critical years of a child's life. These kits help address developmental milestone delays by giving children opportunities to learn through play, exploration, and hands-on experiences. Volunteers don't just build kits—they help create brighter beginnings for children by providing resources that support healthy early development and school readiness.",
  highlights: ['Early Learning Kits', 'Developmental Stimulation'],
  icon: 'blocks',
  accent: '#1565c0',
},
  {
  title: 'Create4Inclusion',
  image: require('../../Assest/Volunteering/inclusion.png'),
  tag: 'Inclusive Education',
  description:
    "Create4Inclusion empowers volunteers to assemble inclusive learning and sensory kits for children with disabilities. Each kit is thoughtfully designed with educational, tactile, and sensory materials that support cognitive, motor, communication, and social development. By creating these accessible learning resources, volunteers help children engage in meaningful play, overcome learning barriers, and experience a more inclusive and stimulating environment at home and in the classroom.",
  highlights: ['Inclusive Learning Kits', 'Sensory Stimulation'],
  icon: 'puzzle',
  accent: '#d32f2f',
},
];

/* ---------- Reused card, identical markup/classes to ProjectCard ---------- */
const VolunteerCard = ({ title, tag, image, description, highlights, icon, accent }) => {
  const [expanded, setExpanded] = useState(false);
  const toggleExpand = () => setExpanded(!expanded);

  const previewText =
    description.length > 160 ? description.slice(0, 160).trim() + '…' : description;

  return (
    <div className="project-card" style={{ '--seal-color': accent }}>
      <div className="project-card-media">
        <img src={image} alt={title} />
        <span className="project-seal">
          <Icon name={icon} />
        </span>
      </div>

      <div className="project-card-body">
        <span className="project-tag">{tag}</span>
        <h3 className="project-title">{title}</h3>

        <p className="project-description">{expanded ? description : previewText}</p>

        <ul className="project-highlights">
          {highlights.map((h) => (
            <li key={h}>{h}</li>
          ))}
        </ul>

        <button type="button" className="project-learn-more" onClick={toggleExpand}>
          {expanded ? 'Show less' : 'Learn more'}
          <span className={`arrow ${expanded ? 'up' : ''}`}>→</span>
        </button>
      </div>
    </div>
  );
};

/* ---------- Card ---------- */
const ProjectCard = ({ title, tag, image, description, highlights, icon, accent }) => {
  const [expanded, setExpanded] = useState(false);
  const toggleExpand = () => setExpanded(!expanded);

  const previewText =
    description.length > 160 ? description.slice(0, 160).trim() + '…' : description;

  return (
    <div className={`project-card accent-${accent}`}>
      <div className="project-card-media">
        <img src={image} alt={title} />
        <span className="project-seal">
          <Icon name={icon} />
        </span>
      </div>

      <div className="project-card-body">
        <span className="project-tag">{tag}</span>
        <h3 className="project-title">{title}</h3>

        <p className="project-description">{expanded ? description : previewText}</p>

        <ul className="project-highlights">
          {highlights.map((h) => (
            <li key={h}>{h}</li>
          ))}
        </ul>

        <button type="button" className="project-learn-more" onClick={toggleExpand}>
          {expanded ? 'Show less' : 'Learn more'}
          <span className={`arrow ${expanded ? 'up' : ''}`}>→</span>
        </button>
      </div>
    </div>
  );
};

const ProjectPage = () => {

  const [showAll, setShowAll] = useState(false);

  const displayedProjects = showAll ? projects : projects.slice(0, 6);

  return (
    <div className="project-page">

      <section
        className="project-hero"
        style={{ backgroundImage: `url(${projects[2].image})` }}
      >
        <div className="project-hero-overlay" />

        <div className="container project-hero-inner">
          <div className="project-hero-copy">
            <h1 className="hero-title">Our Projects</h1>

            <h2 className="hero-subtitle">
              Building stronger communities.
              <br />
              Creating <span className="highlight">lasting impact.</span>
            </h2>

            <p>
              Explore the programmes through which HDSI is transforming lives
              across India.
            </p>

            <div className="hero-features">
              <div className="feature">
                <span className="feature-icon">
                  <Icon name="heart" />
                </span>
                <span className="feature-label">
                  Holistic
                  <br />
                  Approach
                </span>
              </div>

              <span className="feature-divider" />

              <div className="feature">
                <span className="feature-icon">
                  <Icon name="pin" />
                </span>
                <span className="feature-label">
                  Rooted in
                  <br />
                  Communities
                </span>
              </div>

              <span className="feature-divider" />

              <div className="feature">
                <span className="feature-icon">
                  <Icon name="sprout" />
                </span>
                <span className="feature-label">
                  Sustainable
                  <br />
                  Change
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="project-gallery">

        <div className="container">

          <div className="section-heading">
            <span className="eyebrow">— Our Focus Areas —</span>

            <h2>
              Holistic programmes for inclusive, sustainable development
            </h2>
          </div>

          <Row className="g-4">

            {displayedProjects.map((project) => (

              <Col md={4} sm={6} key={project.title}>

                <ProjectCard {...project} />

              </Col>

            ))}

          </Row>

          {!showAll && (

            <div className="load-more-btn">

              <Button
                variant="primary"
                className="hdsi-btn"
                onClick={() => setShowAll(true)}
              >
                Load More Projects
              </Button>

            </div>

          )}

        </div>

      </section>

      <section className="volunteer-section">
  <div className="container">

    <div className="section-heading">
      <span className="eyebrow">— OUR KEY VOLUNTEERING PROGRAMS —</span>
      <h2>Volunteer to Create Lasting Change</h2>
      <p>Hands-on. Heartfelt. High Impact.</p>
    </div>

    <Row className="g-4">
      {volunteerPrograms.map((program) => (
        <Col md={4} sm={6} key={program.title}>
          <VolunteerCard {...program} />
        </Col>
      ))}
    </Row>

  </div>
</section>

      <Footer />

    </div>
  );
};

export default ProjectPage;